/**
 * Formats a locale string to proper case (e.g., "en-us" → "en-US")
 * @param {string} locale - The locale string to format
 * @returns {string} The formatted locale string
 */
export function formatLocale(locale) {
  if (!locale || typeof locale !== 'string') {
    return locale;
  }

  const parts = locale.split('-');
  if (parts.length === 1) {
    return parts[0].toLowerCase();
  }

  return `${parts[0].toLowerCase()}_${parts[1].toUpperCase()}`;
}
